/* eslint-disable @typescript-eslint/no-redeclare */
export const PORTO_BUILDING_ID = '034afa2fd84945a0b8558d52f1bc1ce2';
export type PORTO_BUILDING_ID = typeof PORTO_BUILDING_ID;

export const LISBON_BUILDING_ID = 'd414ce78e35643a9a730c8bcce24af1e';
export type LISBON_BUILDING_ID = typeof LISBON_BUILDING_ID;
